import * as trace from 'owa-trace';
import changeIsLoading from '../../actions/changeIsLoading';
import { isOpx } from 'owa-opx';
import { lazyLoadOptions } from 'owa-outlook-service-options';
import { loadLgpdOption } from '../../actions/lgpd/lgpdOptionsActions';
import { orchestrator } from 'satcheljs';

/**
 * For OPX scenarios, we need to warm up the cache as it currently does not happen due to
 * the startup data call and the session data calls are not returning the correct values for the AdMarket field
 * in the owaUserConfig. Till this issue is resolved,
 * We manually load the Options data for GDPR page on load on AdvertisingGdpr component.
 */
export const loadLgpdOptionOrchestrator = orchestrator(loadLgpdOption, async () => {
    // return if in a non OPX scenario
    if (!isOpx()) {
        return;
    }

    changeIsLoading(true);

    try {
        await lazyLoadOptions.importAndExecute();

        changeIsLoading(false);
    } catch (e) {
        trace.errorThatWillCauseAlert(
            `loadLgpdOptionOrchestrator: Failed to lazyLoadOptions ${e.message}`
        );
    }
});
